type Props = {
  name: string;
  fill?: 0 | 1;
  fontSize?: string | number;
  weight?: number;
  grade?: number;
  opsz?: number;
  className?: string;
  style?: React.CSSProperties;
  "data-testid"?: string;
};

const fontSizeMap = {
  inherit: "inherit",
  small: "20px",
  medium: "24px",
  large: "36px",
};

export default function Icon({
  name,
  fill = 0,
  weight = 400,
  grade = 0,
  opsz = 24,
  className = "",
  fontSize = "medium",
  style = {},
  "data-testid": dataTestId,
  ...rest
}: Props) {
  const resolvedFontSize = typeof fontSize === "string" ? fontSizeMap[fontSize] || fontSize : fontSize;
  return (
    <span
      className={`material-symbols-outlined ${className}`}
      style={{
        fontVariationSettings: `"FILL" ${fill}, "wght" ${weight}, "GRAD" ${grade}, "opsz" ${opsz}`,
        fontSize: resolvedFontSize,
        ...style,
      }}
      data-testid={dataTestId || name}
      {...rest}
    >
      {name}
    </span>
  );
}
